import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";

export const getDetailJurnal = createAsyncThunk("detail/getDetail", async (id, { rejectWithValue }) => {
    try {
        const response = await axios.get(
            getBaseUrl + '/api/jurnal-guru/' + id,
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})


const jurnalDetailSlice = createSlice({
    name: 'jurnalDetail',
    initialState: {
        detailData: {},
        loading: false,

        statusResApi: '',
        messageResApi: '',
        isDisplayMessage: false,
    },
    reducers: {
        updateStateDetailJurnal: (state, action) => {
            const { name, value } = action.payload
            state[name] = value
        },
        resetDetail: (state) => {
            state.detailData = {}
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDetailJurnal.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDetailJurnal.fulfilled, (state, action) => {
                state.loading = false;
                state.detailData = action.payload.data;
            })
            .addCase(getDetailJurnal.rejected, (state, action) => {
                state.loading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })

    }
})

export const { updateStateDetailJurnal, resetDetail } = jurnalDetailSlice.actions
export default jurnalDetailSlice.reducer;